"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var theme_1 = require("../theme"); // tslint:disable-line
var getStyles = function (_a) {
    var theme = _a.theme, boxSizing = _a.boxSizing, margin = _a.margin, marginTop = _a.marginTop, marginLeft = _a.marginLeft, marginRight = _a.marginRight, marginBottom = _a.marginBottom, marginX = _a.marginX, marginY = _a.marginY, padding = _a.padding, paddingTop = _a.paddingTop, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight, paddingBottom = _a.paddingBottom, paddingX = _a.paddingX, paddingY = _a.paddingY, top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom, width = _a.width, height = _a.height, minWidth = _a.minWidth, minHeight = _a.minHeight, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, backgroundColor = _a.backgroundColor, color = _a.color, border = _a.border, borderTop = _a.borderTop, borderLeft = _a.borderLeft, borderRight = _a.borderRight, borderBottom = _a.borderBottom, borderRadius = _a.borderRadius, borderColor = _a.borderColor, display = _a.display, position = _a.position, order = _a.order, lineHeight = _a.lineHeight, textAlign = _a.textAlign, verticalAlign = _a.verticalAlign, flex = _a.flex, flexWrap = _a.flexWrap, flexDirection = _a.flexDirection, alignItems = _a.alignItems, justifyContent = _a.justifyContent, alignSelf = _a.alignSelf, overflow = _a.overflow, overflowX = _a.overflowX, overflowY = _a.overflowY, tabIndex = _a.tabIndex, hidden = _a.hidden, center = _a.center;
    var space = theme.space, palette = theme.palette, radii = theme.radii;
    return {
        alignSelf: alignSelf,
        border: border,
        boxSizing: boxSizing,
        borderBottom: borderBottom,
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        flex: flex,
        flexDirection: flexDirection,
        flexWrap: flexWrap,
        height: height,
        hidden: hidden,
        lineHeight: lineHeight,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        order: order,
        overflow: overflow,
        overflowX: overflowX,
        overflowY: overflowY,
        position: position,
        textAlign: textAlign,
        tabIndex: tabIndex,
        verticalAlign: verticalAlign,
        width: width,
        margin: space[margin] || margin,
        marginTop: space[marginTop] || space[marginY] || marginTop || marginY,
        marginLeft: space[marginLeft] || space[marginX] || marginLeft || marginX,
        marginRight: space[marginRight] || space[marginX] || marginRight || marginX,
        marginBottom: space[marginBottom] || space[marginY] || marginBottom || marginY,
        padding: space[padding],
        paddingTop: space[paddingTop] || space[paddingY],
        paddingLeft: space[paddingLeft] || space[paddingX],
        paddingRight: space[paddingRight] || space[paddingX],
        paddingBottom: space[paddingBottom] || space[paddingY],
        top: space[top],
        left: space[left],
        right: space[right],
        bottom: space[bottom],
        color: palette[color],
        backgroundColor: palette[backgroundColor],
        borderRadius: radii[borderRadius],
        borderColor: palette[borderColor],
        display: center ? display || 'flex' : display,
        alignItems: center ? alignItems || 'center' : alignItems,
        justifyContent: center ? justifyContent || 'center' : justifyContent,
    };
};
/**
 * @component
 */
var BoxStyled = theme_1.styled('div')(function (props) { return getStyles(props); });
var Box = /** @class */ (function (_super) {
    tslib_1.__extends(Box, _super);
    function Box(props) {
        var _this = _super.call(this, props) || this;
        _this.boxComponent = props.as ? BoxStyled.withComponent(props.as) : BoxStyled;
        return _this;
    }
    Box.prototype.render = function () {
        var Component = this.boxComponent;
        var _a = this.props, children = _a.children, restProps = tslib_1.__rest(_a, ["children"]);
        return (react_1.default.createElement(Component, tslib_1.__assign({}, restProps), children));
    };
    Box.defaultProps = {
        boxSizing: 'border-box'
    };
    return Box;
}(react_1.default.PureComponent));
exports.default = Box;
